
export default {
  props: {
    defaults: {
      type: Object,
      default: () => ({})
    },
    enabled: {
      type: Boolean,
      default: true
    },
    bubbleLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      passengers: {
        adults: 1,
        children: 0
      }
    }
  },
  computed: {
    text () {
      const text = []
      Object.entries(this.passengers).forEach((entry) => {
        const quantity = parseInt(entry[1], 10)
        if (quantity) {
          const term = this.$tc(`flights.passengers.templates.${entry[0]}`, quantity)
          text.push(`${quantity} ${term}`)
        }
      })
      return text.join(', ')
    }
  },
  watch: {
    enabled (value) {
      if (!value) this.isOpen = false
    }
  },
  created () {
    this.passengers.adults = this.defaults.adults || 1
    this.passengers.children = this.defaults.children || 0
  },
  mounted () {
    this._closePassengersFromElsewhere = () => {
      if (this.isOpen) this.close()
    }
    this.$root.$on('close-passengers-dropdown', this._closePassengersFromElsewhere)
  },
  beforeDestroy () {
    this.$root.$off('close-passengers-dropdown', this._closePassengersFromElsewhere)
  },
  methods: {
    toggle () {
      if (!this.enabled) return false
      if (this.isOpen) return this.close()
      return this.open()
    },
    open () {
      this.$root.$emit('close-all-airport-autocompletes')
      this.$root.$emit('close-all-date-pickers')
      this.$root.$emit('close-cabin-class-dropdown')
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    away () {
      if (this.isOpen) {
        this.close()
      }
    },
    update (data) {
      this.passengers[data.name] = data.count
      return this.$emit('update', data)
    }
  }
}
